import React from "react";
import withRouter from "../../../../common/hooks/withRouter";
import {connect} from "react-redux";
import {Filter} from "../../../../common/components/Filter";
import {setKYCServicesFilter, updateKYCFilters} from "../../actions/ServicesActions";

export class KYCListSidebarFilters extends React.Component {

    handleDPFilter = (filterOption) => {
        this.props.setKYCServicesFilter(filterOption, "provider");
        this.props.updateKYCFilter();
    }

    handleVerifiableElementsFilter = (filterOption) => {
        this.props.setKYCServicesFilter(filterOption, "verifiable_elements");
        this.props.updateKYCFilter();
    }

    handleStatusFilter = (filterOption) => {
        this.props.setKYCServicesFilter(filterOption, "status");
        this.props.updateKYCFilter();
    }

    handleInvoiceNameFilter = (filterOption) => {
        this.props.setKYCServicesFilter(filterOption, "invoice_name");
        this.props.updateKYCFilter();
    }

    render() {

        return (
            <div className="sidebar-filter-container">
                <Filter
                    placeholder="Data Provider"
                    handleFilter={this.handleDPFilter}
                    options={this.props.filterOptions.dpFilterOptions}
                    value={this.props.filters.providerNameFilter}
                />
                <Filter
                    placeholder="Status"
                    handleFilter={this.handleStatusFilter}
                    options={this.props.filterOptions.statusOptions}
                    value={this.props.filters.statusFilter}
                />
                <Filter
                    placeholder="Matching Elements"
                    isMulti={true}
                    handleFilter={this.handleVerifiableElementsFilter}
                    options={this.props.filterOptions.verifiableElementsOptions}
                    value={this.props.filters.verifiableElementsFilter}
                />
                <Filter
                    placeholder="Invoice Name"
                    handleFilter={this.handleInvoiceNameFilter}
                    options={this.props.filterOptions.invoiceNameOptions}
                    value={this.props.filters.invoiceNameFilter}
                />
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    serviceType: state.veritas.services.type,
    filterOptions: state.veritas.services.filterOptions,
    filters: state.veritas.services.filters,
    kyc_services: state.veritas.services.kyc_services,
});

const mapDispatchToProps = dispatch => ({
    setKYCServicesFilter: (filterOption, type) => {dispatch(setKYCServicesFilter(filterOption, type))},
    updateKYCFilter: () => {dispatch(updateKYCFilters())},
});

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps,
)(KYCListSidebarFilters))
